import moment from "moment"

export const hasFinanceData = (state) => {
  return state.hasFinanceData
}

export const financeData = (state) => {
  return state.financeData
}

export const invoiceSettings = (state) => {
  return state.invoiceSettings
}

export const adRevenue = (state) => {
  if (!state.financeData) return []
  return state.financeData.map((a) => (a.audioAdRevenue || 0) + (a.displayAdRevenue || 0) + (a.directAdRevenue || 0))
}

export const adRevenueTotal = (state, getters) => {
  return getters.audioAdRevenueTotal + getters.displayAdRevenueTotal + getters.directAdRevenueTotal
}

export const audioAdImpressions = (state) => {
  if (!state.financeData) return []
  return state.financeData.map((a) => a.audioAdImpressions || 0)
}

export const audioAdImpressionsTotal = (state, getters) => {
  return getters.audioAdImpressions.reduce((a, b) => a + b, 0)
}

export const audioAdRevenue = (state) => {
  if (!state.financeData) return []
  return state.financeData.map((a) => a.audioAdRevenue || 0)
}

export const audioAdRevenueTotal = (state, getters) => {
  return getters.audioAdRevenue.reduce((a, b) => a + b, 0)
}

export const displayAdImpressions = (state) => {
  if (!state.financeData) return []
  return state.financeData.map((a) => a.displayAdImpressions || 0)
}

export const displayAdImpressionsTotal = (state, getters) => {
  return getters.displayAdImpressions.reduce((a, b) => a + b, 0)
}

export const displayAdRevenue = (state) => {
  if (!state.financeData) return []
  return state.financeData.map((a) => a.displayAdRevenue || 0)
}

export const displayAdRevenueTotal = (state, getters) => {
  return getters.displayAdRevenue.reduce((a, b) => a + b, 0)
}

export const directAdImpressions = (state) => {
  if (!state.financeData) return []
  return state.financeData.map((a) => a.directAdImpressions || 0)
}

export const directAdImpressionsTotal = (state, getters) => {
  return getters.directAdImpressions.reduce((a, b) => a + b, 0)
}

export const directAdRevenue = (state) => {
  if (!state.financeData) return []
  return state.financeData.map((a) => a.directAdRevenue || 0)
}

export const directAdRevenueTotal = (state, getters) => {
  return getters.directAdRevenue.reduce((a, b) => a + b, 0)
}

// SurferNETWORK's source-split revenue contract reports the network share under
// `programmaticNetworkRevenue` rather than the legacy audio/display fields.
export const isProgrammaticNetworkRevenueAvailable = (state) => {
  return (
    Array.isArray(state.financeData) &&
    state.financeData.length > 0 &&
    state.financeData.every((entry) => Number.isFinite(entry.programmaticNetworkRevenue))
  )
}

export const programmaticNetworkRevenue = (state) => {
  if (!state.financeData) return []
  return state.financeData.map((entry) =>
    Number.isFinite(entry.programmaticNetworkRevenue) ? entry.programmaticNetworkRevenue : 0
  )
}

export const programmaticNetworkRevenueTotal = (state, getters) => {
  return getters.programmaticNetworkRevenue.reduce((a, b) => a + b, 0)
}

export const isPodcastRevenueAvailable = (state) => {
  return state.isPodcastRevenueAvailable
}

export const podcastAdEntries = (state) => {
  const entries = state.podcastRevenue?.entries

  return Array.isArray(entries) ? entries : []
}

// The report is requested at the same aggregation as the rest of the page, so entries
// only need relabelling to line up with the shared `timePeriods` categories.
export const podcastAdDates = (state, getters) => {
  const format = getters.isDaily ? "YYYY-MM-DD" : "MMM, YYYY"

  return getters.podcastAdEntries.map((e) => moment.utc(e.date).format(format))
}

export const podcastAdRevenue = (state, getters) => {
  return getters.podcastAdEntries.map((e) => e.revenue || 0)
}

export const podcastAdRevenueTotal = (state, getters) => {
  return getters.podcastAdRevenue.reduce((a, b) => a + b, 0)
}

export const podcastAdImpressions = (state, getters) => {
  return getters.podcastAdEntries.map((e) => e.impressions || 0)
}

export const podcastAdImpressionsTotal = (state, getters) => {
  return getters.podcastAdImpressions.reduce((a, b) => a + b, 0)
}

// Per-podcast breakdown for the selected period, ordered biggest-earner-first so the bar
// chart reads top-down. The report supplies the title, but it is null for a podcast that
// has since been deleted — those are labelled by key rather than dropped, since their
// revenue still counts towards the period.
export const podcastAdRevenueByPodcast = (state) => {
  const breakdown = state.podcastRevenueByPodcast?.podcasts
  if (!Array.isArray(breakdown)) return []

  return breakdown
    .map((p) => ({
      key: p.podcastKey,
      title: p.title || p.podcastKey,
      revenue: p.revenue || 0,
      impressions: p.impressions || 0,
    }))
    .sort((a, b) => b.revenue - a.revenue)
}

export const isDaily = (state) => {
  return state.financeFrequency === "daily"
}

export const timePeriods = (state, getters) => {
  if (!state.financePeriod.from || !state.financePeriod.to) return []

  const start = moment.utc(state.financePeriod.from)
  const end = moment.utc(state.financePeriod.to)
  const arr = []

  if (getters.isDaily) {
    const dt = start.clone()
    while (dt.isSameOrBefore(end, "day")) {
      arr.push(dt.format("YYYY-MM-DD"))
      dt.add(1, "day")
    }
  } else {
    const diffInMonths = Math.abs(start.diff(end, "months"))

    for (let i = 0; i <= diffInMonths; i++) {
      arr.push(start.clone().add(i, "months").format("MMM, YYYY"))
    }
  }

  return arr
}
